export const decodeId = (base64string) => {
  if (!base64string) {
    return null;
  }
  if (parseInt(base64string)) {
    return base64string;
  }
  let decoded = atob(base64string).split(":");
  return decoded[1];
};

export const capitalize = (string) => {
  string = removeUnderscores(string);
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const capitalizeAllWords = (string) => {
  string = removeUnderscores(string);

  let capitalized = string.split(" ").map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`);
  return capitalized?.toString().replace(",", " ") ?? "";
};

export const removeUnderscores = (string) => {
  return string?.replaceAll("_", " ") ?? "";
};

export const toUpperCaseUnderscore = (string) => {
  return string?.toUpperCase().replace(" ", "_") ?? "";
};

export const truncate = (string, length, useWordBoundary = true) => {
  if (string.length <= length) {
    return string;
  }
  const subString = string.substr(0, length - 1);
  return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString) + "...";
};

export const IdToNode = (id, nodeType = "UserNode") => {
  return window.btoa(`${nodeType}:${id}`);
}